$('.js-loaderButton').on('click', (e) => {
  e.preventDefault()

  $(e.currentTarget).addClass('is_loading')
})
